// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5.2 12.6C3.16 12.6 1.5 10.94 1.5 8.9C1.5 7.78 1.97 6.79 2.71 6.11M5.97 2.57C6.42 2.36 6.92 2.25 7.45 2.25C9.11 2.25 10.47 3.41 10.85 5.03C10.97 5.54 11.06 5.82 11.54 5.9C13.23 6.18 14.5 7.54 14.5 9.22C14.5 9.77 14.37 10.28 14.14 10.74M9.2 12.6L5.2 12.6',
  'M2 2L14 14',
];
